import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MAPS = {
  'g i': '/inbox',
  'g m': '/mailbox',
  'g d': '/dashboard',
  'g s': '/suppliers',
  'g c': '/customers',
  'g t': '/team',
};

export default function KeyboardShortcuts() {
  const nav = useNavigate();
  const [buffer, setBuffer] = useState('');
  const [showHelp, setShowHelp] = useState(false);

  useEffect(() => {
    let timer = null;
    function onKey(e) {
      if (['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === '?') { e.preventDefault(); setShowHelp(true); return; }
      if (e.key === 'Escape') { setShowHelp(false); return; }
      const next = (buffer + e.key).slice(-3).trim();
      setBuffer(next);
      clearTimeout(timer);
      timer = setTimeout(() => setBuffer(''), 1000);
      const target = MAPS[next];
      if (target) {
        e.preventDefault();
        setBuffer('');
        nav(target);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('keydown', onKey); clearTimeout(timer); };
  }, [buffer, nav]);

  if (!showHelp) return null;
  return (
    <div role="dialog" aria-label="Keyboard shortcuts" style={{ position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)', zIndex: 80, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowHelp(false)}>
      <div className="card" style={{ width: 480, background: '#fff' }} onClick={(e) => e.stopPropagation()}>
        <h2 className="card-title">Keyboard shortcuts</h2>
        <table className="table">
          <tbody>
            <tr><td><kbd>g i</kbd></td><td>Go to RFQs</td></tr>
            <tr><td><kbd>g m</kbd></td><td>Go to Mailbox</td></tr>
            <tr><td><kbd>g d</kbd></td><td>Go to Dashboard</td></tr>
            <tr><td><kbd>g s</kbd></td><td>Go to Suppliers</td></tr>
            <tr><td><kbd>g c</kbd></td><td>Go to Customers</td></tr>
            <tr><td><kbd>g t</kbd></td><td>Go to Team</td></tr>
            <tr><td><kbd>/</kbd></td><td>Focus global search</td></tr>
            <tr><td><kbd>?</kbd></td><td>Show this help</td></tr>
            <tr><td><kbd>Esc</kbd></td><td>Close dialogs</td></tr>
          </tbody>
        </table>
        <div style={{ textAlign: 'right' }}><button className="btn btn-secondary btn-sm" onClick={() => setShowHelp(false)}>Close</button></div>
      </div>
    </div>
  );
}
